"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalNavService = void 0;
var PRODUCT;
(function (PRODUCT) {
    PRODUCT["AFFIRM"] = "affirm";
    PRODUCT["EUREKA_MATH_NAV"] = "em-nav";
    PRODUCT["INKLING"] = "inkling";
    PRODUCT["EQUIP"] = "equip";
})(PRODUCT || (PRODUCT = {}));
var GlobalNavService = /** @class */ (function () {
    function GlobalNavService(isStudent) {
        this.abortManager = new AbortController();
        this.isStudent = isStudent;
    }
    GlobalNavService.prototype.get = function () {
        return fetch(GlobalNavService.path, { signal: this.abortManager.signal })
            .then(function (res) { return res.json(); })
            .then(function (data) { return data; });
    };
    GlobalNavService.prototype.isProduct = function (id) {
        return GlobalNavService.appsByProduct.includes(id);
    };
    GlobalNavService.prototype.serializeCurriculumLabel = function (curriculumName) {
        return curriculumName.replace(' Squared', '²');
    };
    GlobalNavService.prototype.serializeProductLabel = function (productLabel) {
        return productLabel.replace('Inkling', 'Digital Teacher Edition').replace('Equip', 'Affirm');
    };
    GlobalNavService.prototype.serializeProductId = function (productId) {
        return productId.replace('equip', 'affirm');
    };
    GlobalNavService.prototype.serializeProductName = function (productId) {
        return productId.replace('Equip', 'Affirm');
    };
    GlobalNavService.prototype.abort = function () {
        this.abortManager.abort();
    };
    GlobalNavService.prototype.filterApps = function (apps) {
        var _this = this;
        var uniqueById = function (uniqueApps, item) {
            var uniqueAppId = !uniqueApps.some(function (prevItem) { return prevItem.id === item.id; });
            var uniqueProductName = !uniqueApps.some(function (prevItem) { return prevItem.productName === item.productName; });
            var uniqueProductWhenTeacher = uniqueProductName && !_this.isStudent;
            if (uniqueAppId || uniqueProductWhenTeacher)
                uniqueApps.push(item);
            return uniqueApps;
        };
        var productsUrls = apps
            .filter(function (_a) {
            var id = _a.id;
            return _this.isProduct(id);
        })
            .map(function (item) { return item.redirectionUrl; });
        var filterProductUrls = function (item) {
            return _this.isProduct(item.id) || !productsUrls.includes(item.redirectionUrl);
        };
        return apps.filter(filterProductUrls).reduce(uniqueById, []);
    };
    GlobalNavService.prototype.getApps = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, curriculums, apps, appsFiltered;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get()];
                    case 1:
                        response = _a.sent();
                        curriculums = response.data.curriculums;
                        apps = curriculums.map(function (app) {
                            if (!_this.isStudent && _this.isProduct(app.product.id)) {
                                return {
                                    label: _this.serializeProductLabel(app.product.name),
                                    ariaLabel: _this.serializeProductLabel(app.product.name),
                                    id: _this.serializeProductId(app.product.id),
                                    redirectionUrl: app.redirectionUrl,
                                    imageSrc: app.product.thumbnailUrl,
                                    productName: _this.serializeProductName(app.product.name),
                                };
                            }
                            return {
                                label: _this.serializeCurriculumLabel(app.curriculum.name),
                                ariaLabel: app.curriculum.name,
                                id: app.curriculum.id,
                                redirectionUrl: app.redirectionUrl,
                                imageSrc: app.curriculum.thumbnailUrl,
                                productName: app.product.name,
                            };
                        });
                        appsFiltered = this.filterApps(apps);
                        return [2 /*return*/, appsFiltered];
                }
            });
        });
    };
    GlobalNavService.appsByProduct = [
        PRODUCT.AFFIRM,
        PRODUCT.EUREKA_MATH_NAV,
        PRODUCT.INKLING,
        PRODUCT.EQUIP,
    ];
    GlobalNavService.path = '/student-app-switcher/api/apps';
    return GlobalNavService;
}());
exports.GlobalNavService = GlobalNavService;
